<script lang="ts">
    import type {
        EasyVrpCalculationResponseType,
    } from './EasyVrpCalculationApi';
    import { EasyVrpApp } from './EasyVrpApp';
    import { getContrastTextColor, LABEL_BORDER_COLOR } from './EasyVrpMap/StyleUtils';
    import { mapContext } from './EasyVrpMap/MapContext';
    import { get } from 'svelte/store';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import ModalTimeStory from './ModalTimeStory.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import Time from '../../shared/Time.svelte';
    import Distance from '../../shared/Distance.svelte';
    import type { RouteToDrawType } from './EasyVrpApp.types';

    export let result: EasyVrpCalculationResponseType;
    export let showResult: (resultId: number, selectedRouteId: string | null) => void;

    let currentRouteId: string | null = null;
    let isCurrentResult: boolean = false;

    function showTimeStory(route: RouteToDrawType) {
        openModal(ModalCustom, {
            component: ModalTimeStory,
            componentProps: {
                route,
            },
        });
    }

    $: isCurrentResult = get(mapContext)?.getSelectedCalcId() === result?.id;
    $: currentRouteId =
        (get(mapContext)?.getSelectedRouteId() !== null && isCurrentResult
            ? get(mapContext)?.getSelectedRouteId()
            : null) ?? null;
    //
    let total_time_minutes: number =
        result.routes_to_draw.reduce(
            (acc, route) => acc + (route.summary.time_minutes ?? 0),
            0
        ) ?? 0;
    let total_time_driving_minutes: number =
        result.routes_to_draw.reduce(
            (acc, route) => acc + (route.summary.time_driving_minutes ?? 0),
            0
        ) ?? 0;
    let total_time_stops_minutes: number =
        result.routes_to_draw.reduce(
            (acc, route) => acc + (route.summary.time_stops_minutes ?? 0),
            0
        ) ?? 0;
    let fix_total_time_minutes: boolean = total_time_minutes < total_time_driving_minutes;

    let total_distance_km: number = Math.round(
        result.routes_to_draw.reduce(
            (acc, route) => acc + (route.summary.distance_km ?? 0),
            0
        ) ?? 0
    );
</script>

<div class="scrollable-table">
    <table class="table">
        <thead>
            <tr>
                <th></th>
                <th>Pojazd</th>
                <th>Dystans</th>
                <th>Czas całḱ.</th>
                <th>Czas jazdy</th>
                <th>Czas doręcz.</th>
                <th
                    title="Pojemność pojazdu wg której zostały uwzględnione limity (kg lub przesyłki - zgodnie z ustawieniem 'Co traktować jako graniczną ładowność pojazdu?')"
                    >Pojemność graniczna</th
                >
                <th>Stopów</th>
                <th title="Maksymalna chwilowa waga przesyłek w pojeździe">Max [kg]</th>
                <th title="Maksymalna chwilowa liczba przesyłek w pojeździe">Max [*]</th>
                <th title="Liczba okien czasowych dla doręczeń/odbiorów (z wyjątkiem magazynu)"
                    >Okien czasowych</th
                >
                <th title="Suma przekroczeń okien czasowych w minutach">Przekroczeń [min]</th>
            </tr>
        </thead>
        <tbody>
            <!--{#if result?.summary?.calculation_summary_routes}-->
                <tr class="summary-row">
                    <td>
                        <Checkbox
                            label=""
                            disabled={currentRouteId === null && isCurrentResult}
                            checked={currentRouteId === null && isCurrentResult}
                            onChange={checked => {
                                currentRouteId = null;
                                showResult(result.id, currentRouteId);
                            }}
                        />
                    </td>
                    <td>{result.routes_to_draw.length ?? '---'}</td>
                    <td>
                        <Distance meters={total_distance_km * 1000} />
                    </td>
                    <td>
                        {#if !fix_total_time_minutes}
                            <Time seconds={total_time_minutes * 60} />
                        {:else}
                            <!-- hack for invalid total_time_minutes -->
                            <Time
                                seconds={(total_time_driving_minutes + total_time_stops_minutes) *
                                    60}
                            />
                        {/if}
                    </td>
                    <td>
                        <Time seconds={total_time_driving_minutes * 60} />
                    </td>
                    <td>
                        <Time seconds={total_time_stops_minutes * 60} />
                    </td>
                    <td>
                        {result.routes_to_draw.reduce(
                            (acc, route) => acc + (route.summary.package_count ?? 0),
                            0
                        )}
                    </td>
                    <td>
                        {result.routes_to_draw.reduce(
                            (acc, route) => acc + (route.summary.stop_count ?? 0),
                            0
                        )}
                    </td>
                    <td>
                        {result.routes_to_draw
                            .reduce((acc, route) => Math.max(acc, route.summary.max_capacity_kg ?? 0), 0)
                            ?.toFixed(0) ?? '---'}
                    </td>
                    <td>
                        {result.routes_to_draw
                            .reduce(
                                (acc, route) => Math.max(acc, route.summary.max_capacity_packages ?? 0),
                                0
                            )
                            ?.toFixed(0) ?? '---'}
                    </td>
                    <td>
                        {result.routes_to_draw.reduce(
                            (acc, route) => acc + (route.summary.window_time_count ?? 0),
                            0
                        ) ?? '---'}
                    </td>
                    <td>
                        {result.routes_to_draw.reduce(
                            (acc, route) => acc + (route.summary.window_time_exceeded_minutes ?? 0),
                            0
                        ) ?? '---'}
                    </td>
                    <!--                    <td></td>-->
                </tr>
                {#if result?.routes_to_draw}
                {#each result?.routes_to_draw as route}
                    <tr>
                        <td>
                            <Checkbox
                                label=""
                                checked={(currentRouteId === null ||
                                    currentRouteId === route.uniqueRouteId) &&
                                    isCurrentResult}
                                onChange={checked => {
                                    console.log('Checkbox onChange', {
                                        checked,
                                        currentRouteId,
                                        routeId: route.uniqueRouteId,
                                    });
                                    if (
                                        currentRouteId === null ||
                                        currentRouteId !== route.uniqueRouteId
                                    ) {
                                        currentRouteId = route.uniqueRouteId ?? null;
                                    } else {
                                        currentRouteId = null;
                                    }
                                    showResult(result.id, currentRouteId);
                                }}
                            />
                        </td>
                        <td
                            ><div
                                data-route-color={route?.color}
                                style="background-color: {(currentRouteId === null ||
                                    currentRouteId === route.uniqueRouteId) &&
                                isCurrentResult
                                    ? route.color
                                    : '#ffffff'}; text-align: center; border: 1px solid {LABEL_BORDER_COLOR}; border-radius: 4px; padding: 0 4px;"
                            >
                                <span
                                    style="font-weight: 600; color: {(currentRouteId === null ||
                                        currentRouteId === route.uniqueRouteId) &&
                                    isCurrentResult
                                        ? getContrastTextColor(route?.color ?? '#000000')
                                        : '#000000'}">{route?.name ?? '---'}</span
                                >
                            </div></td
                        >
                        <td>
                            {#if route.summary.distance_km}
                                <Distance meters={route.summary.distance_km * 1000} />
                            {/if}
                        </td>
                        <td>
                            {#if fix_total_time_minutes}
                                <Time
                                    seconds={((route.summary.time_driving_minutes ?? 0) +
                                        (route.summary.time_stops_minutes ?? 0)) *
                                        60}
                                />
                            {:else}
                                <Time seconds={(route.summary.time_minutes ?? 0) * 60} />
                            {/if}
                        </td>
                        <td><Time seconds={(route.summary.time_driving_minutes ?? 0) * 60} /></td>
                        <td><Time seconds={(route.summary.time_stops_minutes ?? 0) * 60} /></td>
                        <td>{route.summary.package_count ?? '---'}</td>
                        <td>{route.summary.stop_count ?? '---'}</td>
                        <td> {route.summary.max_capacity_kg?.toFixed(0) ?? '---'}</td>
                        <td> {route.summary.max_capacity_packages?.toFixed(0) ?? '---'}</td>
                        <td>{route.summary.window_time_count ?? '---'}</td>
                        <td
                            ><LinkSmallBlack
                                text={route.summary.window_time_exceeded_minutes?.toString() ?? '---'}
                                on:click={() => {
                                    showTimeStory(route);
                                }}
                            /></td
                        >
                    </tr>
                {/each}
                {/if}
                <!--{JSON.stringify(result?.summary?.calculation_summary_routes)}-->
            <!--{/if}-->
        </tbody>
    </table>
</div>

<style>
    .scrollable-table {
        overflow-y: auto;
        max-height: 256px;
        padding: 0 10px 0 0;
    }
    .scrollable-table > .table {
        width: 100%;
        border-collapse: collapse;
    }
    .table th {
        background-color: #f2f2f2;
        color: #333;
        text-align: right;
        position: sticky;
        top: 0;
    }

    .table th,
    .table td {
        padding: 3px;
        font-weight: normal;
        text-align: right;
    }
    .table tbody tr {
        background-color: #fff;
        scroll-snap-align: start; /* https://www.youtube.com/watch?v=uMtyxRSqxIk */
    }
    .table tbody tr:nth-child(even) {
        background-color: #f9f9f9;
    }
    .table tbody tr.summary-row {
        background-color: #e0e0e0;
        font-weight: 600;
    }
    .table tbody tr.summary-row td {
        font-weight: 600;
    }
    .table tbody tr.clickable {
        cursor: pointer;
    }
</style>
